import { initPdfJs } from '../../../utils/pdfLoader';

const MAX_DIMENSION = 2600;
const THUMBNAIL_DIMENSION = 200;

const renderPageToBlob = async (page, maxDimension) => {
    const renderScale = 3.0;
    const viewport = page.getViewport({ scale: renderScale });

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const renderContext = {
        canvasContext: context,
        viewport: viewport,
    };

    await page.render(renderContext).promise;

    if (viewport.width > maxDimension || viewport.height > maxDimension) {
        const widthScale = maxDimension / viewport.width;
        const heightScale = maxDimension / viewport.height;
        const scale = Math.min(widthScale, heightScale);

        const targetWidth = Math.floor(viewport.width * scale);
        const targetHeight = Math.floor(viewport.height * scale);

        const resizeCanvas = document.createElement('canvas');
        const resizeContext = resizeCanvas.getContext('2d');
        resizeCanvas.width = targetWidth;
        resizeCanvas.height = targetHeight;

        resizeContext.imageSmoothingEnabled = true;
        resizeContext.imageSmoothingQuality = 'high';
        resizeContext.drawImage(canvas, 0, 0, targetWidth, targetHeight);

        return new Promise((resolveBlob) => {
            resizeCanvas.toBlob((blob) => {
                resolveBlob(blob);
            }, 'image/png');
        });
    }

    return new Promise((resolveBlob) => {
        canvas.toBlob((blob) => {
            resolveBlob(blob);
        }, 'image/png');
    });
};

export const convertPdfToThumbnails = async (pdfFile, onProgress) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();

        fileReader.onload = async function () {
            try {
                const typedArray = new Uint8Array(this.result);
                
                const pdfjsLib = await initPdfJs();
                const loadingTask = pdfjsLib.getDocument({ data: typedArray });
                const pdf = await loadingTask.promise;
                const numPages = pdf.numPages;
                const thumbnails = [];

                for (let pageNum = 1; pageNum <= numPages; pageNum++) {
                    if (onProgress) {
                        onProgress(pageNum, numPages);
                    }

                    const page = await pdf.getPage(pageNum);
                    const thumbnailBlob = await renderPageToBlob(page, THUMBNAIL_DIMENSION);

                    thumbnails.push({
                        pageNumber: pageNum,
                        thumbnail: thumbnailBlob,
                    });
                }

                resolve({ thumbnails, pageCount: numPages });
            } catch (error) {
                reject(error);
            }
        };

        fileReader.onerror = function () {
            reject(new Error('Failed to read PDF file'));
        };

        fileReader.readAsArrayBuffer(pdfFile);
    });
};

export const convertPdfToImages = convertPdfToThumbnails;
